module.exports = __webpack_public_path__ + "img/20190624161620207.fd89d7fe.png";